import { useCallback, useReducer } from 'react';

export const useModalControl = <TModalData extends unknown>() => {
  type State = {
    modalData: TModalData | null,
    isModalVisible: boolean,
  }

  type Action = {
    type: 'show',
    data: TModalData | null
  } | {
    type: 'hide'
  }

  const [{ modalData, isModalVisible }, dispatch] = useReducer((state: State, action: Action) => {
    switch (action.type) {
      case 'show': {
        return {
          modalData: action.data,
          isModalVisible: true,
        };
      }
      case 'hide': {
        return {
          modalData: null,
          isModalVisible: false,
        };
      }
      default: {
        return state;
      }
    }
  }, { modalData: null, isModalVisible: false });

  return {
    isModalVisible,
    modalData,
    showModal: useCallback((data: TModalData | null = null) =>
      dispatch({ type: 'show', data })
    , []),
    hideModal: useCallback(() =>
      dispatch({ type: 'hide' })
    , []),
  };
};
